import { createFileRoute } from "@tanstack/react-router";
import {
  type ModelsLocation,
  ModelsWorkspace,
  readModelsLocation,
} from "@/features/models/ModelsWorkspace";
export const Route = createFileRoute("/_authenticated/models")({
  staticData: { access: { anyOf: ["agents.manage"] } },
  validateSearch: (search: Record<string, unknown>): ModelsLocation => readModelsLocation(search),
  head: () => ({ meta: [{ title: "Models · Pax.co" }] }),
  component: Page,
});
function Page() {
  const location = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ModelsWorkspace
      location={location}
      navigate={(search, options) => void navigate({ search, replace: options?.replace })}
    />
  );
}
